// extracted by mini-css-extract-plugin
var _1 = "ra-art-option-frame";
var _2 = "ra-art-option-frame-description";
var _3 = "ra-art-option-frame-list";
var _4 = "ra-art-option-frame-list-item";
export { _1 as "artOptionFrameCls", _2 as "artOptionFrameDescriptionCls", _3 as "artOptionFrameListCls", _4 as "artOptionFrameListItemCls" }
